import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import Compliance_Section1 from "./sections/Compliance_Section1";

function LandlordCompliance() {
  usePageMeta({
    title: "Landlord Compliance & Certification Ireland | Spechs",
    description:
      "Landlord compliance and certification services across Ireland. Stay legally compliant with expert support.",
    canonical: "https://www.spechs.ie/property/compliance/",
  });
  return (
    <SubPageLayout title="Landlord Compliance & Certification">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <Compliance_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default LandlordCompliance;
